/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type BuySharedNullSearchResults_buyPage$ref = any;
export type BuySharedNullSearchResults_buyPage = {
    readonly metadata: {
        readonly header: string | null;
    } | null;
    readonly " $refType": BuySharedNullSearchResults_buyPage$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedNullSearchResults_buyPage",
  "type": "BuyPageConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "metadata",
      "storageKey": null,
      "args": null,
      "concreteType": "MetaData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "header",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '1b4e52c06ff683e321579b17e377aba7';
export default node;
